import { Language } from 'src/app/util/lang';
import { IBreadCrumb } from './../../interfaces/breadcrumb.interface';
import { Component, OnInit } from "@angular/core";
import { ActivatedRoute, Router, NavigationEnd } from "@angular/router";
import { filter } from "rxjs/operators";
import { Input } from "@angular/core";
import { Location } from "@angular/common";
import { PaymentService } from 'src/app/services/payment.service';
import { TranslateService } from '@ngx-translate/core';


@Component({
  selector: "app-bread-crumbs",
  templateUrl: "./bread-crumbs.component.html",
  styleUrls: ["./bread-crumbs.component.scss"]
})
export class BreadCrumbsComponent implements OnInit {
  @Input()
  public deliminator: string = ">";
  public providerTree: any;
  public breadcrumbs: Array<IBreadCrumb>;
  public curretBreadCrumb: string;
  public currentPath: string;

  constructor(
    private router: Router,
    public location: Location,
    public paymentService: PaymentService,
    public translate: TranslateService
  ) { }

  public generateBreadCrumbs(): void {
    const pathname = this.location.path();
    const splitedPathname = pathname.substring(1).split('/');
    this.breadcrumbs = [];
    let path = splitedPathname[1];
    let pathId = splitedPathname[2] ? splitedPathname[2] : null;
    this.currentPath = path;
    const lang = Language.getCurrentLang();
    this.translate.get('Title').subscribe((data) => {
      const { TitleHistory, receipt, pay } = data;
      this.paymentService.getProviderTree(pathId).subscribe(response => {
        if (response instanceof Array) {
          response.forEach((item, index) => {
            this.breadcrumbs.push({
              label: item.Name,
              url: this.createUrl(path, item.Id, index, response.length)
            });
          });
          if (path == `paymenthistory`) {
            this.breadcrumbs.push({
              label: TitleHistory,
              url: 'paymenthistory'
            });
          }
          else if (path == `receipt`) {
            this.breadcrumbs.push({
              label: TitleHistory,
              url: 'paymenthistory'
            }, {
              label: receipt,
              url: `receipt/${pathId}`
            });
          }
          else if (path == `pay`) {
            this.breadcrumbs.push({
              label: pay,
              url: `pay/${pathId}`
            });
          };
          this.breadcrumbs = [...new Map(this.breadcrumbs.map(item => [item.label, item])).values()];
        };
      });
    });

  }

  public createUrl(path: string, Id: string, index: number, navigationLength): string {
    let url;
    const lang = Language.getCurrentLang();
    switch (path) {
      case `pay`: {
        if (++index == navigationLength) {
          url = `${lang}/provider/${Id}`;
        } else {
          url = `${lang}/providers/${Id ? Id : ''}`;
        }
        break;
      }
      case `provider`: {
        url = ++index == navigationLength ? `${lang}/provider/${Id}` : `${lang}/providers/${Id ? Id : ''}`;
        break;
      }
      default:
        {
          url = `${lang}/providers/${Id ? Id : ''}`;
          break;
        }
    }
    return url;
  }

  ngOnInit() {
    this.router.events
      .pipe(filter(event => event instanceof NavigationEnd))
      .subscribe(event => {
        this.generateBreadCrumbs();
      });
  }
}
